import { Menu, MenuItem, MenuProps } from '@mui/material';
import * as React from 'react';
import { Key, useCallback } from 'react';
import clsx from 'clsx';
import styles from './AppMenu.module.scss';
import { anchorTransformOrigin } from './anchorTransformOrigin';
import { MenuDirection } from './MenuDirection';

/*
 * For menu positioning you could experiment on https://mui.com/material-ui/react-popover/#anchor-playground
 */
export type AppCustomMenuProps = MenuProps & {
  /*
   * You could use this prop instead of `anchorOrigin` & `transformOrigin`.
   * If `direction` is specified it takes the priority over `anchorOrigin` & `transformOrigin`.
   */
  direction?: MenuDirection;

  closeOnClick?: boolean;

  testId?: string;
};

const classes: MenuProps['classes'] = {
  paper: styles.paper,
  list: styles.list,
};
export const AppCustomMenu: React.FC<AppCustomMenuProps> = (props) => {
  const { direction, closeOnClick, testId, ...rest } = props;
  const onClose: NonNullable<MenuProps['onClose']> = useCallback(
    (e: any, reason) => {
      e.stopPropagation();
      props.onClose?.(e, reason);
    },
    [props.onClose],
  );
  const onClick: NonNullable<MenuProps['onClick']> = useCallback(
    (e) => {
      e.stopPropagation();
      if (!!closeOnClick) {
        props.onClose?.(e, 'backdropClick');
      }
      props.onClick?.(e);
    },
    [props.onClick, closeOnClick],
  );

  return (
    <Menu
      {...rest}
      data-test-id={testId}
      transitionDuration={0}
      {...(direction !== undefined
        ? anchorTransformOrigin[direction]
        : undefined)}
      classes={classes}
      onClose={onClose}
      onClick={onClick}
    />
  );
};
